import type { EnhancedLegacyManCode } from '#api/enhancements/enhancedTg3Payload'
import type { EnhancedConfigTypeId, EnhancedMarketId, EnhancedVehicleTypeId, EnhancedViewId } from '#api/enhancements/enhancedTmsApiTypes'
import type { FullApiConfiguration } from '#features/Configuration/ApiConfiguration'
import { toastError } from '#features/ErrorHandling/toastError'
import { lookupMarketAndLanguageMapping } from '#features/Markets/lookupMarketAndLanguageMapping'

export async function deriveApiConfigurationFromTg3Code(tg3Code: EnhancedLegacyManCode): Promise<FullApiConfiguration> {
  // find matching market by tg3Code country and language

  const languageCode: string | undefined = tg3Code.configuration?.locale ?? 'de'
  const countryCode = tg3Code.configuration?.orderCountry ?? 'DE'

  const marketMapping = await lookupMarketAndLanguageMapping(countryCode, languageCode)

  if (
    marketMapping.marketId === undefined ||
    marketMapping.languageId === undefined ||
    marketMapping.viewId === undefined ||
    marketMapping.vehicleTypeId === undefined
  ) {
    toastError('Failed to derive market and language from TG3 code')
    return {
      orderCountry: countryCode,
      orderLanguage: languageCode,
      market: 1 as EnhancedMarketId,
      vehicleType: 0 as EnhancedVehicleTypeId,
      configurationType: 0 as EnhancedConfigTypeId,
      view: 0 as EnhancedViewId,
    }
  }

  return {
    orderCountry: marketMapping.countryCode ?? countryCode,
    orderLanguage: marketMapping.languageCode ?? languageCode,
    market: marketMapping.marketId,
    language: marketMapping.languageId,
    vehicleType: marketMapping.vehicleTypeId,
    configurationType: marketMapping.configurationTypeId,
    view: marketMapping.viewId,
  }
}
